import * as z from "zod/v4";

export const editLinearComment = {
  name: "editLinearComment" as const,
  input: z.object({
    linearTicketId: z.string(),
    commentId: z.string(),
    body: z.string(),
  }),
  output: z.object({ success: z.boolean(), slackSuccess: z.boolean() }),
};
